export default function initVideoLightbox() {
    const lightbox = document.querySelector(".video-lightbox");
    const openButton = document.querySelector(".video-button");

    let active = false;
    let requestId = null;

    if(lightbox) {
        const video = lightbox.querySelector("video");
        const closeButton = lightbox.querySelector(".lightbox-close");
        openButton.addEventListener("click", open);
        closeButton.addEventListener("click", close);
        document.addEventListener("scroll", onScroll);

        function open() {
            video.play();
            lightbox.classList.add("active");
            active = true;
        }

        function close() {
            video.pause();
            video.currentTime = 0;
            lightbox.classList.remove("active");
            active = false;
        }

        function onScroll() {
            if (!requestId) {
            requestId = requestAnimationFrame(update);
            }
        }

        function update() {
            if(active) {
                close();
            }
            requestId = null;
        }
    }
}